<template>
  <div class="name-input-page">
    <h2>لطفا نام خود را وارد کنید</h2>
    <input v-model="name" placeholder="" id="input_name" />
    <button @click="submitName">تایید</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
    };
  },
  methods: {
    submitName() {
      if (this.name) {
        localStorage.setItem("userName", this.name); // Store the name for later use
        this.$router.push("/description"); // Navigate to the image classification page
      } else {
        const Element = document.getElementById("input_name");
        Element.style.border = "5px solid red";

        // alert("Please enter your name");
      }
    },
  },
};
</script>

<style>
.name-input-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 1px;
}

input {
  padding: 10px;
  margin: 10px 0;
}

button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}
</style>
